import React, { useEffect, useState } from 'react';
import api from '../api/api';

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
}

const AuthorizedApiImage: React.FC<Props> = ({ src, alt = '', ...imageProps }) => {
  const [resolved, setResolved] = useState<{ source: string; url: string } | null>(null);

  useEffect(() => {
    let active = true;
    let objectUrl: string | null = null;
    if (!/^\/(?:dishes\/\d+\/photo|kitchenware\/items\/\d+\/photo|uploads\/recipe-steps\/[a-fA-F0-9]{32}\.jpg)$/.test(src)) {
      setResolved({ source: src, url: src });
      return () => { active = false; };
    }

    setResolved(null);
    api.get<Blob>(src, { responseType: 'blob' })
      .then(({ data }) => {
        if (!active) return;
        objectUrl = URL.createObjectURL(data);
        setResolved({ source: src, url: objectUrl });
      })
      .catch(() => { if (active) setResolved(null); });
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src]);

  if (!resolved || resolved.source !== src) return null;
  return <img {...imageProps} src={resolved.url} alt={alt} />;
};

export default AuthorizedApiImage;
